import React from 'react';
import ActivityCardCollapsed from './ActivityCardCollapsed';
import PressableScale from '@shared/components/md-design-system/Button/PressableScaleButton';
import { View } from 'react-native';
import { colorPalette } from '@shared/config/colorsConfig';
import { dynamicTranslations, generateActivityTitleTranslation } from '@shared/utils/dynamicTranslation';


function ActivityButton({ activityName, onPress, disabled: isDisabled = false, activityType }: { activityName: string, onPress: () => void, disabled?: boolean, activityType: string }) {
    const { t } = dynamicTranslations();

    const onPressHandler = async () => onPress();
    const isActive = true;
    const completed = false;
    const loading = false;
    const disabled = isDisabled || loading || (!isActive && !completed);

    const translatedTitle = generateActivityTitleTranslation(activityName, activityType, 'activity');

    return (
        <View style={{
            shadowColor: '#000000',
            shadowOpacity: 0.1,
            shadowRadius: 6,
            shadowOffset: { width: 0, height: 2 },
            elevation: 3,
        }} className="mb-3 rounded-[20px]">
            <PressableScale
                onPress={onPressHandler}
                disabled={disabled}
                borderRadius={20}
                rippleColor={colorPalette.primary[100]}
                pressedTintColor={colorPalette.primary[100]}
                frameClassName={`rounded-[20px] border  ${disabled ? 'border-gray-200 bg-gray-200' : 'border-gray-300 bg-white'
                    }`}
                pressedFrameClassName={!disabled ? 'border-primary-700' : ''}
                contentClassName="px-6 py-5 rounded-[20px]"
                contentStyle={{
                    minHeight: 60,
                    justifyContent: 'center',
                }}
            >
                {({ pressed }) => (
                    <ActivityCardCollapsed
                        title={translatedTitle}
                        isPressed={pressed && !disabled}
                    />
                )}
            </PressableScale>
        </View >
    );
}

export default ActivityButton;
